import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  selector: 'offer-list-modal',
  templateUrl: './offer-list-modal.component.html',
  styleUrls: ['./offer-list-modal.component.scss'],
})
export class OfferListModalComponent implements OnInit {
  @Input() offerList: any;
  @Input() selectedVariantId: string = '';
  public currentHeaderData: any = {
    title: 'modals.offer_list_modal.header',
    subtitle: '',
    modalSlotEnd: true,
    marl20: true,
    mart4: '4px',
    isSafeArea: true
  };
  constructor(private modalController: ModalController, private analyticsService: AnalyticsService) {}

  ngOnInit() {}

  /**
   * Returns true if the offer is applicable to the currently selected variant.
   * SKU-level offers (skuLevelOffer === true) are only valid when the
   * selectedVariantId is present in their applicableVariantIds list.
   */
  isOfferApplicable(item: any): boolean {
    if (!!item?.active !== true && !!item?.locked !== false) return false;
    if (item?.skuLevelOffer && Array.isArray(item?.applicableVariantIds)) {
      return this.selectedVariantId
        ? item.applicableVariantIds.includes(this.selectedVariantId)
        : false;
    }
    return true;
  }

  getOfferTitle(item: any): string {
    if (item?.campaignDetail?.offerTitle) {
      return item.campaignDetail.offerTitle;
    } else if (item.title) {
      return item.title;
    } else {
      return '';
    }
  }

  ApplyOffer(appliedOffer) {
    const campaignId =
      appliedOffer?.campaignDetail?.campaignId ?? appliedOffer?.campaignId ?? appliedOffer?.offerId  ;
    this.modalController.dismiss(campaignId);
  }

  closeModal() {
    this.analyticsService.trackUnified('offer_list_modal_closed', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Offer List Modal Closed',
      component: 'offer-list-modal',
    });
    this.modalController.dismiss();
  }
}
